const possibleChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
export const generateRandomString = (length: number) =>
  new Array(length)
    .fill(0)
    .map(() => possibleChars.charAt(Math.floor(Math.random() * possibleChars.length)))
    .join('');
